import { ISite, SiteKind } from "containers/sites-manager/hooks";
import { isLocalUrl } from "./index";

export interface IRouter {
    pathname: string[];
    location: {
        query: {
            redirect?: string;
            mobile?: string;
        };
        pathname: string;
    };
    replace(target: { pathname: string }): void;
}

export const PAGE_LINK_ATTR = "data-page-link";

export const parsePageUrl = (url: string): { siteSlug?: string; pageId?: string } => {
    const pattern = new RegExp("/site/(.+[^/])?/page/(.+[^/])?/?", "i");
    const matches = url.match(pattern);

    return {
        siteSlug: matches?.[1],
        pageId: matches?.[2],
    };
};

export const getSitePageUrl = (siteSlug: string, pageId: string, brandId?: string): string => {
    if (brandId) {
        return `/brand/${brandId}/site/${siteSlug}/page/${pageId}`;
    } else {
        return `/site/${siteSlug}/page/${pageId}`;
    }
};

export const adjustPageLinks = (container: HTMLElement, site: ISite) => {
    const ANCHOR = "a";
    const elements = Array.from(container.querySelectorAll(`[${PAGE_LINK_ATTR}]`));
    elements.forEach((element) => {
        let link = element as HTMLAnchorElement;
        if (link.tagName.toLowerCase() !== ANCHOR) {
            [link] = Array.from(element.getElementsByTagName(ANCHOR));
        }
        const href = link?.href;
        if (href && isLocalUrl(href)) {
            const { pageId } = parsePageUrl(href);
            if (pageId) {
                link.href = getSitePageUrl(site.slug, pageId, site.kind === SiteKind.Brand && site.brand_id);
            }
        }
    });
};

export const isMobilePage = (router: IRouter) =>
    (router.location.pathname.includes("/site") || router.location.pathname.includes("/terms-and-conditions")) &&
    router.location.query.mobile === "true";
